
namespace TabAurous.Production {

    @Serenity.Decorators.registerClass()
    export class MFGTransactionBOMDialog extends _Ext.MFGTransBOMEditorDialog<MFGTransactionBOMRow> {
        protected getFormKey() { return MFGTransactionBOMForm.formKey; }
        protected getIdProperty() { return MFGTransactionBOMRow.idProperty; }
        protected getLocalTextPrefix() { return MFGTransactionBOMRow.localTextPrefix; }
        protected getNameProperty() { return MFGTransactionBOMRow.nameProperty; }

        protected form = new MFGTransactionBOMForm(this.idPrefix);

    }
}